<template>
  <div>
    <b-menu-list :label="$t('compEcolabwareDocsMenu.label-1')">
      <b-menu-item
        :active="buffer === 'ecolabware-notes'"
        @click="activate('ecolabware-notes')"
      >
        <template slot="label">
          <nav class="level">
            <div class="level-left">
              <div class="level-item">
                <b-icon icon="life-ring"></b-icon>
                {{ $t('compEcolabwareDocsMenu.label-2') }}
              </div>
            </div>
          </nav>
        </template>
      </b-menu-item>
      <b-menu-item
        :active="buffer === 'ecolabware-team'"
        @click="activate('ecolabware-team')"
      >
        <template slot="label">
          <nav class="level">
            <div class="level-left">
              <div class="level-item">
                <b-icon icon="users"></b-icon>
                {{ $t('compEcolabwareDocsMenu.label-3') }}
              </div>
            </div>
          </nav>
        </template>
      </b-menu-item>
    </b-menu-list>
  </div>
</template>

<script>
export default {
  name: 'Menu',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      buffer: this.value
    }
  },
  watch: {
    value: function () {
      this.buffer = this.value
    }
  },
  methods: {
    activate: function (val) {
      this.buffer = val
      this.$emit('input', this.buffer)
    }
  }
}
</script>
